import { Controller } from "@hotwired/stimulus"

// Handles PWA install prompt on the profile page.
// - On Android/Desktop Chrome/Edge: triggers native install prompt via beforeinstallprompt
// - On iOS: shows a bottom sheet with browser-specific instructions
export default class extends Controller {
  static targets = [
    "installButton",
    "backdrop",
    "sheet",
    "safariSteps",
    "chromeIosSteps",
    "firefoxIosSteps"
  ]

  connect() {
    // Already running as installed PWA — hide the button
    if (window.matchMedia("(display-mode: standalone)").matches || navigator.standalone) {
      this.installButtonTarget.classList.add("hidden")
      return
    }

    // Show the button (hidden by default in markup)
    this.installButtonTarget.classList.remove("hidden")

    // Capture the deferred prompt (Chrome, Edge, Samsung Internet on Android/desktop)
    this._onBeforeInstall = (e) => {
      e.preventDefault()
      this.deferredPrompt = e
    }
    window.addEventListener("beforeinstallprompt", this._onBeforeInstall)
  }

  disconnect() {
    if (this._onBeforeInstall) {
      window.removeEventListener("beforeinstallprompt", this._onBeforeInstall)
    }
  }

  async install() {
    // Native prompt available (Android Chrome, Desktop Chrome/Edge)
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt()
      const { outcome } = await this.deferredPrompt.userChoice
      if (outcome === "accepted") {
        this.installButtonTarget.classList.add("hidden")
      }
      this.deferredPrompt = null
      return
    }

    // iOS — detect which browser and show the right steps
    const ua = navigator.userAgent
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
      this._hideAllSteps()

      if (/CriOS/.test(ua)) {
        this.chromeIosStepsTarget.classList.remove("hidden")
      } else if (/FxiOS/.test(ua)) {
        this.firefoxIosStepsTarget.classList.remove("hidden")
      } else {
        // Default to Safari instructions
        this.safariStepsTarget.classList.remove("hidden")
      }

      this.backdropTarget.classList.remove("hidden")
      this.sheetTarget.classList.remove("hidden")
    }
  }

  closeSheet() {
    this.backdropTarget.classList.add("hidden")
    this.sheetTarget.classList.add("hidden")
  }

  // Private

  _hideAllSteps() {
    this.safariStepsTarget.classList.add("hidden")
    this.chromeIosStepsTarget.classList.add("hidden")
    this.firefoxIosStepsTarget.classList.add("hidden")
  }
}
